import { render, staticRenderFns } from "./EditBranch.vue?vue&type=template&id=71c8c0ee&"
import script from "./EditBranch.vue?vue&type=script&lang=js&"
export * from "./EditBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports